import { TOAST_NOTIFICATION_TYPES } from '@/features/toast-notifications/components/ToastNotification/constants';
import { isAuthorizationError } from 'utils/errors';

import {
  ADD_TOAST_NOTIFICATION,
  ATTEMPT_GET_MEMBER_PREFERENCES,
  ATTEMPT_UPDATE_MEMBER,
  ATTEMPT_UPDATE_MEMBER_PREFERENCES,
  ATTEMPT_UPDATE_TRIP_PREFERENCES,
  CLEAR_ALL_TOAST_NOTIFICATIONS,
  CLEAR_FETCH_LOCATION_LOADING_STATE,
  CREATE_ACCESS_TOKEN,
  CREATE_ACCESS_TOKEN_ERROR,
  CREATE_ACCESS_TOKEN_SUCCESS,
  CREATE_APPROVED_LOCATION,
  CREATE_APPROVED_LOCATION_ERROR,
  CREATE_APPROVED_LOCATION_SUCCESS,
  FETCH_LYFT_DRIVER_AVAILABILITY,
  FETCH_LYFT_DRIVER_AVAILABILITY_ERROR,
  FETCH_LYFT_DRIVER_AVAILABILITY_SUCCESS,
  GET_LYFT_TRIP_ESTIMATION,
  GET_MEMBER_ENROLLMENT_COVERAGE_TRIP_COUNTS,
  GET_MEMBER_ENROLLMENT_COVERAGE_TRIP_COUNTS_ERROR,
  GET_MEMBER_ENROLLMENT_COVERAGE_TRIP_COUNTS_SUCCESS,
  GET_MEMBER_PREFERENCES_ERROR,
  GET_MEMBER_PREFERENCES_SUCCESS,
  GET_NEEDS_ACTION_TRIPS_COUNT,
  GET_PROCREDEX_CONNECTION_STATUS,
  GET_PROCREDEX_CONNECTION_STATUS_ERROR,
  GET_PROCREDEX_CONNECTION_STATUS_SUCCESS,
  GET_TRIP_APPROVAL_REASON,
  GET_TRIP_APPROVAL_REASON_ERROR,
  GET_TRIP_APPROVAL_REASON_SUCCESS,
  GET_TRIP_ASSIGNMENT_PREFERENCE,
  GET_TRIP_ASSIGNMENT_PREFERENCE_ERROR,
  GET_TRIP_ASSIGNMENT_PREFERENCE_SUCCESS,
  GET_TRIP_CANCELLATION_REASONS,
  GET_TRIP_CANCELLATION_REASONS_ERROR,
  GET_TRIP_CANCELLATION_REASONS_SUCCESS,
  GET_TRIP_DENIAL_REASONS,
  GET_TRIP_DENIAL_REASONS_ERROR,
  GET_TRIP_DENIAL_REASONS_SUCCESS,
  GET_TRIP_ESCALATION_REASON,
  GET_TRIP_ESCALATION_REASON_ERROR,
  GET_TRIP_ESCALATION_REASON_SUCCESS,
  GET_TRIP_GROUPINGS,
  GET_TRIP_GROUPINGS_ERROR,
  GET_TRIP_GROUPINGS_SUCCESS,
  GET_TRIP_PREFERENCES,
  GET_TRIP_PREFERENCES_ERROR,
  GET_TRIP_PREFERENCES_SUCCESS,
  GET_TRIPS_COUNT,
  GET_UBER_TRIP_ESTIMATION,
  GET_UNREAD_MESSAGE_COUNT,
  GET_UNREAD_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS_ERROR,
  GET_UNREAD_NOTIFICATIONS_SUCCESS,
  GET_VEHICLE_CATEGORIES,
  GET_VEHICLE_CATEGORIES_ERROR,
  GET_VEHICLE_CATEGORIES_SUCCESS,
  GLOBAL_SEARCH,
  GLOBAL_SEARCH_ERROR,
  GLOBAL_SEARCH_SUCCESS,
  ON_ADD_ACTION_ALERT,
  ON_ADD_ALERT_MSG,
  ON_ADD_APP_NOTIFICATION,
  ON_ADD_ERROR,
  ON_ADD_SUCCESS_MSG,
  ON_CHANGE_MENU,
  ON_CHANGE_TAB,
  ON_CHANGE_THEME,
  ON_CLEAR_ALL_ACTION_ALERT,
  ON_CLEAR_ESTIMATES,
  ON_CLEAR_LOCATIONS,
  ON_FETCH_APPOINTMENT_REASONS,
  ON_FETCH_APPOINTMENT_REASONS_ERROR,
  ON_FETCH_APPOINTMENT_REASONS_SUCCESS,
  ON_FETCH_ASSIGNEES,
  ON_FETCH_ASSIGNEES_FAILED,
  ON_FETCH_ASSIGNEES_SUCCESS,
  ON_FETCH_CONTRACTS,
  ON_FETCH_CONTRACTS_ERROR,
  ON_FETCH_CONTRACTS_SUCCESS,
  ON_FETCH_ESTIMATE_ERROR,
  ON_FETCH_ESTIMATE_SUCCESS,
  ON_FETCH_LOCATIONS,
  ON_FETCH_LOCATIONS_FAILED,
  ON_FETCH_LOCATIONS_SUCCESS,
  ON_FETCH_TNC_CONTRACTS_SUCCESS,
  ON_GET_LEVELS_OF_SERVICE,
  ON_GET_LEVELS_OF_SERVICE_ERROR,
  ON_GET_LEVELS_OF_SERVICE_SUCCESS,
  ON_GET_LOCATION_MODIFIERS,
  ON_GET_LOCATION_MODIFIERS_SUCCESS,
  ON_LD_CONTEXT_IDENTIFIED,
  ON_LOAD_ORGANIZATIONS,
  ON_LOAD_ORGANIZATIONS_ERROR,
  ON_LOAD_ORGANIZATIONS_SUCCESS,
  ON_LOAD_ROLES,
  ON_LOAD_ROLES_SUCCESS,
  ON_LOAD_USER,
  ON_LOAD_USER_ERROR,
  ON_LOAD_USER_SUCCESS,
  ON_LOGOUT,
  ON_LOGOUT_SUCCESS,
  ON_MARK_ALL_AS_READ_SUCCESS,
  ON_REMOVE_ACTION_ALERT,
  ON_REMOVE_APP_NOTIFICATION,
  ON_REMOVE_OLDEST_MESSAGE,
  ON_REMOVE_ONE_MESSAGE,
  ON_RESET_LOADING_STATE,
  ON_SELECT_LOCATION,
  ON_SELECT_LOCATION_SUCCESS,
  ON_SET_ACTIVE_ORGANIZATION,
  ON_SET_EXPANDED,
  ON_SET_INACTIVITY_MODAL_VISIBILITY,
  ON_SET_KINETIK_PROXY_TOKEN,
  ON_SET_LYFT_TOKEN,
  ON_SET_UBER_TOKEN,
  ON_TRIP_CHANGE_WATCH_EVENT,
  OPEN_GLOBAL_SEARCH_BOX,
  REMOVE_GLOBAL_SEARCH_VALUE,
  REMOVE_SELECTED_FILTER_DATA,
  REMOVE_TOAST_NOTIFICATION,
  RESET_GLOBAL_SEARCH_RESULTS,
  SEARCH_MEMBERS,
  SEARCH_MEMBERS_ERROR,
  SEARCH_MEMBERS_SUCCESS,
  SELECT_FILTER_DATA,
  SET_GLOBAL_SEARCH_INPUT_VALUE,
  SET_SIDEBAR_MENU_COUNT,
  SET_UNREAD_MESSAGE_COUNT,
  UPDATE_GLOBAL_SEARCHBAR_KEY,
  UPDATE_LEVELS_OF_SERVICE,
  UPDATE_TOAST_NOTIFICATION,
  UPDATE_TRIP_PREFERENCES_FAILED,
  UPDATE_TRIP_PREFERENCES_SUCCESS,
} from './constants';

export function clearEstimates() {
  return {
    type: ON_CLEAR_ESTIMATES,
  };
}

export function setTncContracts(contracts) {
  return {
    type: ON_FETCH_TNC_CONTRACTS_SUCCESS,
    contracts,
  };
}

export function getLyftTripEstimation(trip, assignee, requesterOrganization) {
  return {
    type: GET_LYFT_TRIP_ESTIMATION,
    trip,
    assignee,
    requesterOrganization,
  };
}

export function getUberTripEstimation(trip, assignee, requesterOrganization) {
  return {
    type: GET_UBER_TRIP_ESTIMATION,
    trip,
    assignee,
    requesterOrganization,
  };
}

export function fetchEstimateSuccess(tp, data, tripUuid) {
  return {
    type: ON_FETCH_ESTIMATE_SUCCESS,
    tp,
    data,
    tripUuid,
  };
}

export function fetchEstimateError() {
  return {
    type: ON_FETCH_ESTIMATE_ERROR,
  };
}

export function resetLoadingState() {
  return {
    type: ON_RESET_LOADING_STATE,
  };
}

export function attemptLogout(message) {
  return {
    type: ON_LOGOUT,
    message,
  };
}

export function logoutSuccess() {
  return {
    type: ON_LOGOUT_SUCCESS,
  };
}

/**
 * User-facing text for a failed request.
 *
 * Accepts an axios error, a plain Error, or a ready-made message string --
 * all three are passed to throwError across the codebase.
 *
 * Three things this handles that the previous inline expression did not:
 *
 * 1. A string argument. `throwError('There was an error finding members.')`
 *    read `.message` off a string, which is undefined, so the toast the
 *    caller wrote never appeared (TS-9461's member-search path is one of six
 *    such call sites).
 * 2. A 401/403. The backend's own wording ("Principal is not authorized to
 *    access the resource") was shown verbatim, exposing an internal
 *    authorization string to the user (TS-9459).
 * 3. A response with no `data.message`. `error.response.data.message` threw
 *    outright when `data` was absent, and yielded undefined when `data` had
 *    no message.
 *
 * Any other error keeps the backend's message exactly as before -- those are
 * usually the actionable ones.
 */
export const AUTHORIZATION_ERROR_MESSAGE =
  "You don't have permission to do that. If you think this is a mistake, contact your administrator.";

export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

export function errorMessageFor(error) {
  if (typeof error === 'string') return error;

  if (isAuthorizationError(error)) return AUTHORIZATION_ERROR_MESSAGE;

  return (
    error?.response?.data?.message || error?.message || GENERIC_ERROR_MESSAGE
  );
}

export function throwError(error) {
  return throwMiscError(errorMessageFor(error));
}

export function throwErrorToastNotification(error) {
  return addToastNotification({
    type: TOAST_NOTIFICATION_TYPES.ERROR,
    title: errorMessageFor(error),
    autoHide: true,
  });
}

export function throwMiscError(message) {
  return {
    type: ON_ADD_ERROR,
    message,
  };
}

export function throwSuccessMsg(message, removeCopyMessage = false) {
  return {
    type: ON_ADD_SUCCESS_MSG,
    removeCopyMessage,
    message,
  };
}

/**
 * Long-running work toast: spinner icon, no auto-hide.
 *
 * Stays on screen until the user dismisses it or the caller removes it by uuid
 * (removeToastNotification), because the work it reports on has no fixed
 * duration — an auto-hide would read as 'finished'.
 *
 * @param {Object} params
 * @param {string} params.title       headline, e.g. 'Letter generation in progress'
 * @param {string} [params.description] supporting line under the title
 */
export function throwLoadingToastNotification({ title, description, uuid }) {
  return addToastNotification({
    type: TOAST_NOTIFICATION_TYPES.LOADING,
    title,
    description,
    autoHide: false,
    // Pass a stable uuid when the caller needs to dismiss this toast later —
    // addToastNotification only generates one when it is absent.
    ...(uuid && { uuid }),
  });
}

export function throwSuccessToastNotificaton(message) {
  return addToastNotification({
    type: TOAST_NOTIFICATION_TYPES.SUCCESS,
    title: message,
    autoHide: true,
  });
}

export function throwAlertMsg(
  message,
  redirectUrl = null,
  redirectPageName = '',
) {
  return {
    type: ON_ADD_ALERT_MSG,
    message,
    redirectUrl,
    redirectPageName,
  };
}

export function removeOneMessage(id) {
  return {
    type: ON_REMOVE_ONE_MESSAGE,
    id,
  };
}

export function removeOldestMessage() {
  return {
    type: ON_REMOVE_OLDEST_MESSAGE,
  };
}

export function addActionAlert(alertType, message, action = null) {
  return {
    type: ON_ADD_ACTION_ALERT,
    alertType,
    message,
    action,
  };
}

export function removeActionAlert(uuid) {
  return {
    type: ON_REMOVE_ACTION_ALERT,
    uuid,
  };
}

export function clearActionAlert() {
  return {
    type: ON_CLEAR_ALL_ACTION_ALERT,
  };
}

export function searchMembers(params, orgResourceId, callback = null) {
  return {
    type: SEARCH_MEMBERS,
    params,
    orgResourceId,
    callback,
  };
}

export function searchMembersSuccess(members, totalMemberCount) {
  return {
    type: SEARCH_MEMBERS_SUCCESS,
    members,
    totalMemberCount,
  };
}

export function searchMembersError() {
  return {
    type: SEARCH_MEMBERS_ERROR,
  };
}

export function setActiveTab(tab) {
  return {
    type: ON_CHANGE_TAB,
    tab,
  };
}

export function setActiveMenu(menu) {
  return {
    type: ON_CHANGE_MENU,
    menu,
  };
}

export function setExpanded(expanded) {
  return {
    type: ON_SET_EXPANDED,
    expanded,
  };
}

export function changeTheme(theme) {
  return {
    type: ON_CHANGE_THEME,
    theme,
  };
}

export function loadUser() {
  return {
    type: ON_LOAD_USER,
  };
}

export function userLoaded(user) {
  return {
    type: ON_LOAD_USER_SUCCESS,
    user,
  };
}

export function authError(error) {
  return {
    type: ON_LOAD_USER_ERROR,
    error,
  };
}

export function fetchLocations(key, searchTerm, itemId = null) {
  return {
    type: ON_FETCH_LOCATIONS,
    key,
    searchTerm,
    itemId,
  };
}

export function clearLocations(key) {
  return {
    type: ON_CLEAR_LOCATIONS,
    key,
  };
}

export function fetchLocationsSuccess(key, locations, itemId = null) {
  return {
    type: ON_FETCH_LOCATIONS_SUCCESS,
    key,
    locations,
    itemId,
  };
}

export function clearFetchLocationLoadingState(key = null, itemId = null) {
  return {
    type: CLEAR_FETCH_LOCATION_LOADING_STATE,
    key,
    itemId,
  };
}

export function fetchLocationsError(key, itemId = null) {
  return {
    type: ON_FETCH_LOCATIONS_FAILED,
    itemId,
    key,
  };
}

export function selectLocation(
  key,
  location,
  clearFetchLocationLoadingStateFunc,
  action = null,
  itemId = null,
) {
  return {
    type: ON_SELECT_LOCATION,
    key,
    location,
    action,
    itemId,
    clearFetchLocationLoadingStateFunc,
  };
}

export function selectLocationSuccess(
  key,
  location,
  coords = null,
  itemId = null,
) {
  return {
    type: ON_SELECT_LOCATION_SUCCESS,
    key,
    location,
    coords,
    itemId,
  };
}

export function createAccessToken() {
  return {
    type: CREATE_ACCESS_TOKEN,
  };
}

export function createAccessTokenSuccess(accessToken) {
  return {
    type: CREATE_ACCESS_TOKEN_SUCCESS,
    accessToken,
  };
}

export function createAccessTokenError() {
  return {
    type: CREATE_ACCESS_TOKEN_ERROR,
  };
}

export function loadOrganizations() {
  return {
    type: ON_LOAD_ORGANIZATIONS,
  };
}

export function attemptGetMemberPreferences(orgResourceId) {
  return {
    type: ATTEMPT_GET_MEMBER_PREFERENCES,
    orgResourceId,
  };
}

export function attemptUpdateMemberPreferences(orgResourceId, body) {
  return {
    type: ATTEMPT_UPDATE_MEMBER_PREFERENCES,
    orgResourceId,
    body,
  };
}

export function getMemberPreferencesSuccess(memberPreferences) {
  return {
    type: GET_MEMBER_PREFERENCES_SUCCESS,
    memberPreferences,
  };
}

export function getMemberPreferencesFailed() {
  return {
    type: GET_MEMBER_PREFERENCES_ERROR,
  };
}

export function loadOrganizationsSuccess(organizations) {
  return {
    type: ON_LOAD_ORGANIZATIONS_SUCCESS,
    organizations,
  };
}

export function loadOrganizationsError() {
  return {
    type: ON_LOAD_ORGANIZATIONS_ERROR,
  };
}

export function setInactivityModalVisibility(visibility) {
  return {
    type: ON_SET_INACTIVITY_MODAL_VISIBILITY,
    visibility,
  };
}

export function setKinetikProxyToken(token, expiresIn) {
  return {
    type: ON_SET_KINETIK_PROXY_TOKEN,
    token,
    expiresIn,
  };
}

export function setLyftToken(token, expiresAt) {
  return {
    type: ON_SET_LYFT_TOKEN,
    token,
    expiresAt,
  };
}

export function setUberToken(token, expiresAt) {
  return {
    type: ON_SET_UBER_TOKEN,
    token,
    expiresAt,
  };
}

export function setActiveOrganization(orgResourceId) {
  return {
    type: ON_SET_ACTIVE_ORGANIZATION,
    orgResourceId,
  };
}

export function onMarkAllAsReadSuccess(userUuid) {
  return {
    type: ON_MARK_ALL_AS_READ_SUCCESS,
    userUuid,
  };
}

export function getUnreadNotifications() {
  return {
    type: GET_UNREAD_NOTIFICATIONS,
  };
}

export function getUnreadNotificationsSuccess(notifications, hasUnread) {
  return {
    type: GET_UNREAD_NOTIFICATIONS_SUCCESS,
    notifications,
    hasUnread,
  };
}

export function getUnreadNotificationsError() {
  return {
    type: GET_UNREAD_NOTIFICATIONS_ERROR,
  };
}

export function getLevelsOfService(orgResourceId, params = {}) {
  return {
    type: ON_GET_LEVELS_OF_SERVICE,
    orgResourceId,
    params,
  };
}

export function getLevelsOfServiceSuccess(
  data,
  totalAvailable,
  replace = false,
) {
  return {
    type: ON_GET_LEVELS_OF_SERVICE_SUCCESS,
    data,
    totalAvailable,
    replace,
  };
}

export function getLevelsOfServiceError() {
  return {
    type: ON_GET_LEVELS_OF_SERVICE_ERROR,
  };
}

export const getVehicleCategories = (orgResourceId) => ({
  type: GET_VEHICLE_CATEGORIES,
  orgResourceId,
});

export const getVehicleCategoriesSuccess = (categories) => ({
  type: GET_VEHICLE_CATEGORIES_SUCCESS,
  categories,
});

export const getVehicleCategoriesError = (error) => ({
  type: GET_VEHICLE_CATEGORIES_ERROR,
  error,
});

export function updateLevelsOfService(data) {
  return {
    type: UPDATE_LEVELS_OF_SERVICE,
    data,
  };
}

export function addAppNotification(notification) {
  return {
    type: ON_ADD_APP_NOTIFICATION,
    notification,
  };
}

export function removeAppNotification() {
  return {
    type: ON_REMOVE_APP_NOTIFICATION,
  };
}

export function getLocationModifiers(orgResourceId, params = {}) {
  return {
    type: ON_GET_LOCATION_MODIFIERS,
    orgResourceId,
    params,
  };
}

export function getLocationModifiersSuccess(data) {
  return {
    type: ON_GET_LOCATION_MODIFIERS_SUCCESS,
    data,
  };
}

export function fetchAssignees(orgResourceId) {
  return {
    type: ON_FETCH_ASSIGNEES,
    orgResourceId,
  };
}

export function fetchAssigneesSuccess(assignees) {
  return {
    type: ON_FETCH_ASSIGNEES_SUCCESS,
    assignees,
  };
}

export function fetchAssigneesError() {
  return {
    type: ON_FETCH_ASSIGNEES_FAILED,
  };
}

export function fetchContracts(orgResourceId) {
  return {
    type: ON_FETCH_CONTRACTS,
    orgResourceId,
  };
}

export function fetchContractsSuccess(contracts) {
  return {
    type: ON_FETCH_CONTRACTS_SUCCESS,
    contracts,
  };
}

export function fetchContractsError() {
  return {
    type: ON_FETCH_CONTRACTS_ERROR,
  };
}

export function attemptUpdateMember(orgResourceId, memberUuid, updates) {
  return {
    type: ATTEMPT_UPDATE_MEMBER,
    orgResourceId,
    memberUuid,
    updates: { updates },
  };
}

export function fetchAppointmentReasons(orgResourceId) {
  return {
    type: ON_FETCH_APPOINTMENT_REASONS,
    orgResourceId,
  };
}

export function fetchAppointmentReasonsSuccess(appointmentReasons) {
  return {
    type: ON_FETCH_APPOINTMENT_REASONS_SUCCESS,
    appointmentReasons,
  };
}

export function fetchAppointmentReasonsError() {
  return {
    type: ON_FETCH_APPOINTMENT_REASONS_ERROR,
  };
}

/**
 * Load the current user's role (and so their permissions) for the active org.
 *
 * @param {Object} [options]
 * @param {boolean} [options.isRefresh=false] - a background re-read of an
 *   already-loaded role (e.g. on navigation, TS-9877); a failure keeps the
 *   current role and stays quiet for auth errors instead of toasting
 * @returns {{type: string, isRefresh: boolean}} the action
 */
export function loadRoles({ isRefresh = false } = {}) {
  return {
    type: ON_LOAD_ROLES,
    isRefresh,
  };
}

export function rolesLoaded(role) {
  return {
    type: ON_LOAD_ROLES_SUCCESS,
    role,
  };
}

/**
 * Record that LaunchDarkly's identify() finished for this user and org, so
 * per-org flags read from then on are the org's values (TS-9866).
 *
 * @param {Object} context
 * @param {string} context.key - the user key passed to identify()
 * @param {(string|null)} context.orgResourceId - the org passed to identify()
 * @returns {{type: string, context: {key: string, orgResourceId: (string|null)}}} the action
 */
export function ldContextIdentified({ key, orgResourceId }) {
  return {
    type: ON_LD_CONTEXT_IDENTIFIED,
    context: { key, orgResourceId },
  };
}

export function selectFilterData(selectedFilterData) {
  return {
    type: SELECT_FILTER_DATA,
    selectedFilterData,
  };
}

export function removeSelectedFilterData() {
  return {
    type: REMOVE_SELECTED_FILTER_DATA,
  };
}

export function updateGlobalSearchbarKey() {
  return {
    type: UPDATE_GLOBAL_SEARCHBAR_KEY,
  };
}

export function removeGlobalSearchValue() {
  return {
    type: REMOVE_GLOBAL_SEARCH_VALUE,
  };
}

export function setUnreadMessageCount(unreadMessageCount) {
  return {
    type: SET_UNREAD_MESSAGE_COUNT,
    unreadMessageCount,
  };
}

export function getUnreadMessageCount() {
  return {
    type: GET_UNREAD_MESSAGE_COUNT,
  };
}

export function setGlobalSearchInputValue(value) {
  return {
    type: SET_GLOBAL_SEARCH_INPUT_VALUE,
    value,
  };
}

export function setOpenGlobalSearchbox(value) {
  return {
    type: OPEN_GLOBAL_SEARCH_BOX,
    value,
  };
}

export function handleTripChangeEvent(fullDocument, updateDescription) {
  return {
    type: ON_TRIP_CHANGE_WATCH_EVENT,
    fullDocument,
    updateDescription,
  };
}

export function getTripPreferences(orgResourceId) {
  return {
    type: GET_TRIP_PREFERENCES,
    orgResourceId,
  };
}

export function getTripPreferencesSuccess(tripPreferences) {
  return {
    type: GET_TRIP_PREFERENCES_SUCCESS,
    tripPreferences,
  };
}

export function getTripPreferencesError() {
  return {
    type: GET_TRIP_PREFERENCES_ERROR,
  };
}

export function updateTripPreferences(orgResourceId, body) {
  return {
    type: ATTEMPT_UPDATE_TRIP_PREFERENCES,
    orgResourceId,
    body,
  };
}

export function updateTripPreferencesSuccess(updatedTripPreferences) {
  return {
    type: UPDATE_TRIP_PREFERENCES_SUCCESS,
    updatedTripPreferences,
  };
}

export function updateTripPreferencesFailed() {
  return {
    type: UPDATE_TRIP_PREFERENCES_FAILED,
  };
}

export function getTripCancellationReasons(orgResourceId) {
  return {
    type: GET_TRIP_CANCELLATION_REASONS,
    orgResourceId,
  };
}

export function getTripCancellationReasonsSuccess(tripCancellations) {
  return {
    type: GET_TRIP_CANCELLATION_REASONS_SUCCESS,
    tripCancellations,
  };
}

export function getTripCancellationReasonsError() {
  return {
    type: GET_TRIP_CANCELLATION_REASONS_ERROR,
  };
}

export function getTripDenialReasons(orgResourceId) {
  return {
    type: GET_TRIP_DENIAL_REASONS,
    orgResourceId,
  };
}

export function getTripDenialReasonsSuccess(tripDenials) {
  return {
    type: GET_TRIP_DENIAL_REASONS_SUCCESS,
    tripDenials,
  };
}

export function getTripDenialReasonsError() {
  return {
    type: GET_TRIP_DENIAL_REASONS_ERROR,
  };
}

export function getTripAssignmentPreference(orgResourceId) {
  return {
    type: GET_TRIP_ASSIGNMENT_PREFERENCE,
    orgResourceId,
  };
}

export function getTripAssignmentPreferenceSuccess(preferences) {
  return {
    type: GET_TRIP_ASSIGNMENT_PREFERENCE_SUCCESS,
    preferences,
  };
}

export function getTripAssignmentPreferenceError() {
  return {
    type: GET_TRIP_ASSIGNMENT_PREFERENCE_ERROR,
  };
}

export function setSidebarMenuCounts(key, value) {
  return {
    type: SET_SIDEBAR_MENU_COUNT,
    key,
    value,
  };
}

export function createApprovedLocation(location, orgResourceId, memberUuid) {
  return {
    type: CREATE_APPROVED_LOCATION,
    location,
    orgResourceId,
    memberUuid,
  };
}

export function createApprovedLocationSuccess(location) {
  return {
    type: CREATE_APPROVED_LOCATION_SUCCESS,
    location,
  };
}

export function createApprovedLocationError() {
  return {
    type: CREATE_APPROVED_LOCATION_ERROR,
  };
}

export function fetchLyftDriverAvailability(
  trip,
  assignee,
  requesterOrganization,
) {
  return {
    type: FETCH_LYFT_DRIVER_AVAILABILITY,
    trip,
    assignee,
    requesterOrganization,
  };
}

export function fetchLyftDriverAvailabilitySuccess(availability, tripUuid) {
  return {
    type: FETCH_LYFT_DRIVER_AVAILABILITY_SUCCESS,
    availability,
    tripUuid,
  };
}

export function fetchLyftDriverAvailabilityError() {
  return {
    type: FETCH_LYFT_DRIVER_AVAILABILITY_ERROR,
  };
}

export function getTripsCount({
  query,
  orgResourceId,
  sidebarMenuCountKey,
  countItineraries = false,
  groupBy,
}) {
  return {
    type: GET_TRIPS_COUNT,
    query,
    orgResourceId,
    sidebarMenuCountKey,
    countItineraries,
    groupBy,
  };
}

export function getNeedsActionTripsCount(
  orgResourceId,
  isCorrectionTableEnabled,
) {
  return {
    type: GET_NEEDS_ACTION_TRIPS_COUNT,
    orgResourceId,
    isCorrectionTableEnabled,
  };
}

export function getProCredExConnectionStatus(orgResourceId) {
  return {
    type: GET_PROCREDEX_CONNECTION_STATUS,
    orgResourceId,
  };
}

export function getProCredExConnectionStatusSuccess(
  jobRegistryEntries,
  totalAvailable,
) {
  return {
    type: GET_PROCREDEX_CONNECTION_STATUS_SUCCESS,
    jobRegistryEntries,
    totalAvailable,
  };
}

export function getProCredExConnectionStatusError() {
  return {
    type: GET_PROCREDEX_CONNECTION_STATUS_ERROR,
  };
}

export function getTripEscalationReasons(orgResourceId) {
  return {
    type: GET_TRIP_ESCALATION_REASON,
    orgResourceId,
  };
}

export function getTripEscalationReasonsSuccess(tripEscalationReasons) {
  return {
    type: GET_TRIP_ESCALATION_REASON_SUCCESS,
    tripEscalationReasons,
  };
}

export function getTripEscalationReasonsError() {
  return {
    type: GET_TRIP_ESCALATION_REASON_ERROR,
  };
}

export function getTripApprovalReasons(orgResourceId) {
  return {
    type: GET_TRIP_APPROVAL_REASON,
    orgResourceId,
  };
}

export function getTripApprovalReasonsSuccess(tripApprovalReasons) {
  return {
    type: GET_TRIP_APPROVAL_REASON_SUCCESS,
    tripApprovalReasons,
  };
}

export function getTripApprovalReasonsError() {
  return {
    type: GET_TRIP_APPROVAL_REASON_ERROR,
  };
}

export function getTripGroupings(orgResourceId, params) {
  return {
    type: GET_TRIP_GROUPINGS,
    orgResourceId,
    params,
  };
}

export function getTripGroupingsSuccess(tripGroupings) {
  return {
    type: GET_TRIP_GROUPINGS_SUCCESS,
    tripGroupings,
  };
}

export function getTripGroupingsError() {
  return { type: GET_TRIP_GROUPINGS_ERROR };
}

export function getMemberEnrollmentCoverageTripCounts(
  orgResourceId,
  tripGroupings,
  memberUuid,
  {
    groupNumber,
    medicarePlanCode,
    coverageProgramIdentificationNumber,
    requestedAppointmentReasonsClassification,
    coverageStartDate,
    coverageEndDate,
    years,
    onSuccess,
    onError,
  },
) {
  return {
    type: GET_MEMBER_ENROLLMENT_COVERAGE_TRIP_COUNTS,
    orgResourceId,
    tripGroupings,
    memberUuid,
    groupNumber,
    medicarePlanCode,
    coverageProgramIdentificationNumber,
    requestedAppointmentReasonsClassification,
    coverageStartDate,
    coverageEndDate,
    years,
    onSuccess,
    onError,
  };
}

export function getMemberEnrollmentCoverageTripCountsSuccess(
  memberUuid,
  enrollmentCoverageTripCounts,
  onSuccess,
) {
  return {
    type: GET_MEMBER_ENROLLMENT_COVERAGE_TRIP_COUNTS_SUCCESS,
    memberUuid,
    enrollmentCoverageTripCounts,
    onSuccess,
  };
}

export function getMemberEnrollmentCoverageTripCountsError(onError) {
  return { type: GET_MEMBER_ENROLLMENT_COVERAGE_TRIP_COUNTS_ERROR, onError };
}

export function globalSearch({ orgResourceId, searchValue, includeRequests }) {
  return {
    type: GLOBAL_SEARCH,
    orgResourceId,
    searchValue,
    includeRequests,
  };
}

export function globalSearchSuccess({
  memberResults = {
    data: [],
    totalAvailable: 0,
  },
  tripResults = {
    data: [],
    totalAvailable: 0,
  },
  requestResults = {
    data: [],
    totalAvailable: 0,
  },
  providerResults = {
    data: [],
    totalAvailable: 0,
  },
}) {
  return {
    type: GLOBAL_SEARCH_SUCCESS,
    memberResults,
    tripResults,
    requestResults,
    providerResults,
  };
}

export function globalSearchError(error) {
  return {
    type: GLOBAL_SEARCH_ERROR,
    error,
  };
}

export function resetGlobalSearchResults() {
  return {
    type: RESET_GLOBAL_SEARCH_RESULTS,
  };
}

export function addToastNotification(notification) {
  return {
    type: ADD_TOAST_NOTIFICATION,
    notification: {
      uuid: crypto.randomUUID(),
      ...notification,
    },
  };
}

/**
 * Patches an already-visible toast in place, matched on uuid.
 *
 * Remove-then-add would remount the Snackbar and replay its enter transition,
 * so a toast that changes while on screen — e.g. an action button entering a
 * loading state — is updated rather than recreated. No-ops if the uuid is gone.
 */
export function updateToastNotification(uuid, notification) {
  return {
    type: UPDATE_TOAST_NOTIFICATION,
    uuid,
    notification,
  };
}

export function removeToastNotification(uuid) {
  return {
    type: REMOVE_TOAST_NOTIFICATION,
    uuid,
  };
}

export function clearAllToastNotifications() {
  return {
    type: CLEAR_ALL_TOAST_NOTIFICATIONS,
  };
}

// Re-exported for the modules that already import it from here.
export { isAuthorizationError };
